"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Router.css");
var react_router_dom_1 = require("react-router-dom");
var Router = (function (_super) {
    __extends(Router, _super);
    function Router(props) {
        return _super.call(this, props) || this;
    }
    Router.prototype.render = function () {
        var ReactRouter = react_router_dom_1.HashRouter;
        if (this.props.type == Router.BrowserRouterType)
            ReactRouter = react_router_dom_1.BrowserRouter;
        return (React.createElement(ReactRouter, null,
            React.createElement("div", null, this.props.children)));
    };
    return Router;
}(React.Component));
Router.HashRouterType = "Hash";
Router.BrowserRouterType = "Browser";
Router.defaultProps = {
    children: [],
    type: Router.HashRouterType
};
exports.Router = Router;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['routing'])
        csod.engine.controls['routing'] = {};
    csod.engine.controls['routing']['Router'] = Router;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["Router"] = [];


//////////////////
// WEBPACK FOOTER
// ../player-routing-controls/controls/Router/index.js
// module id = 456
// module chunks = 0